module.exports = __webpack_public_path__ + "img/1-7458.b519c7c8.png";